module.exports = __webpack_public_path__ + "img/carrer-pathways-hero.c6021623.png";